<script lang="ts" setup>
import type { HTMLAttributes } from "vue";
import { reactiveOmit } from "@vueuse/core";
import {
    RangeCalendarHeadCell,
    type RangeCalendarHeadCellProps,
    useForwardProps,
} from "reka-ui";
import { cn } from "@/lib/utils";

const props = defineProps<
    RangeCalendarHeadCellProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = reactiveOmit(props, "class");

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
    <RangeCalendarHeadCell
        :class="
            cn(
                'slt-body-1 slt-flex-center h-[44px] w-[44px] rounded-full font-normal text-neutral-500 dark:text-neutral-400 sm:h-12 sm:w-12',
                props.class,
            )
        "
        v-bind="forwardedProps"
    >
        <slot />
    </RangeCalendarHeadCell>
</template>
